import apiSheet from '@/services/api/sheet';
import specialistPackage from '@/services/api/specialistPackage';

import { getField, updateField } from 'vuex-map-fields';
import fieldRemover from '@/utils/fieldsRemover';
import cloneDeep from 'lodash.clonedeep';
import merge from 'lodash.merge';

const defaultLawyers = () => {
    return {
        scope: [],
        scopeOther: null,
        freeHelp: null,
        paidHelp: null,
        selfHelp: null,
        infoForLawyer: null,
        volunteerHelp: null,
        consentRemote: null,
        helpExplanation: null,
        selfHelpExplanation: null
    };
};
const defaultMedics = () => {
    return {
        checkedMedicalAreas: [],
        otherMedicalAreas: null,
        familyMembers: [],
        familyMembersDescription: null,
        problemDescription: null,
        problemSince: null,
        typeOfHelp: null,
        receivingMedicalHelp: null,
        selfHelp: null,
        infoForMedic: null,
        volunteerHelp: null,
        consentRemote: null,
        selfHelpExplanation: null
    };
};

export default {
    namespaced: true,
    state: {
        resource: null,
        questions: null,
        lawyers: defaultLawyers(),
        medics: defaultMedics(),
        draft: null
    },
    getters: {
        getQuestions: (state) => state.questions,
        getResource: (state) => state.resource,
        getLawyersData (state) {
            return getField(state.lawyers);
        },
        getMedicsData (state) {
            return getField(state.medics);
        },
        getDraft: (state) => state.draft
    },
    mutations: {
        setQuestions (state, data) {
            state.questions = data;
        },
        setResource (state, data) {
            state.resource = data;
        },
        updateLawyersData (state, field) {
            updateField(state.lawyers, field);
        },
        updateMedicsData (state, field) {
            updateField(state.medics, field);
        },
        setLawyersFields (state, data) {
            state.lawyers = merge(state.lawyers, data);
        },
        setMedicsFields (state, data) {
            state.medics = merge(state.medics, data);
        },
        setDraft (state, data) {
            state.draft = data;
        }
    },
    actions: {
        loadPage (context, payload) {
            context
                .dispatch(
                    'family/getFamily',
                    {
                        id: payload.familyId,
                        endpointLabel: 'family'
                    },
                    { root: true }
                )
                .then(({ data }) => {
                    payload.editionName = data.edition.name;
                    if (payload.type === 'lawyers') {
                        payload.setQuestion = data.lawyers_package == null;
                        context.dispatch('loadResource', payload);
                        if (data.lawyers_package != null) {
                            context.dispatch('loadPackage', payload);
                        } else {
                            context.dispatch('loadDraft', payload);
                        }
                    }
                    if (payload.type === 'medics') {
                        payload.setQuestion = data.medics_package == null;
                        context.dispatch('loadResource', payload);
                        if (data.medics_package != null) {
                            context.dispatch('loadPackage', payload);
                        } else {
                            context.dispatch('loadDraft', payload);
                        }
                    }
                });
        },
        loadResource (context, payload) {
            return apiSheet.getResourceSheet(payload.resourceId, payload.editionName).then(({ data }) => {
                if (payload.setQuestion) {
                    if (payload.type === 'lawyers') {
                        context.commit('setQuestions', data.data.sheet_questions.specialist_package[1].lawyers);
                    }
                    if (payload.type === 'medics') {
                        context.commit('setQuestions', data.data.sheet_questions.specialist_package[0].medics);
                    }
                }
                const resource = data.data.sheet_resource;
                apiSheet.getResourceSheet(1, payload.editionName).then(({ data }) => {
                    context.commit('setResource', resource.concat(data.data.sheet_resource));
                });
            });
        },
        loadPackage (context, payload) {
            return specialistPackage.getPackage(payload.familyId, payload.type).then(({ data }) => {
                if (payload.type === 'lawyers') {
                    context.commit('setLawyersFields', data.content);
                    context.commit('setQuestions', data.questions.lawyers);
                }
                if (payload.type === 'medics') {
                    context.commit('setMedicsFields', data.content);
                    context.commit('setQuestions', data.questions.medics);
                }
            });
        },
        loadDraft (context, payload) {
            return specialistPackage.getDraft(payload.familyId, payload.type).then(({ data }) => {
                if (payload.type === 'lawyers') {
                    context.commit('setLawyersFields', data.data);
                }
                if (payload.type === 'medics') {
                    context.commit('setMedicsFields', data.data);
                }
                context.commit('setDraft', data.data);
            });
        },
        saveData (context, payload) {
            const json = cloneDeep(context.state[payload.type]);
            fieldRemover(json);
            return specialistPackage.postPackage(payload.familyId, payload.type, json);
        },
        saveDraft (context, payload) {
            const json = cloneDeep(context.state[payload.type]);
            fieldRemover(json);
            return specialistPackage.saveDraft(payload.familyId, payload.type, {
                specialist_package_draft_json: json
            });
        },
        removeDraft (context, payload) {
            return specialistPackage.removeDraft(payload.familyId, payload.type);
        },
        clear (context) {
            context.state.lawyers = defaultLawyers();
            context.state.medics = defaultMedics();
            context.state.resource = null;
            context.state.questions = null;
            context.state.draft = null;
        }
    }
};
